import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { getDocuments } from "../../redux/actions/actionDocument";
import {
  getInDocuments,
  postInDocuments,
} from "../../redux/actions/actioninDocument";
import { getClientes } from "../../redux/actions/actionClient";
import InDocumentChildCard from "./inDocumentChildCard";
import { format } from "date-fns";
import DatePicker from "react-datepicker";
import Swal from "sweetalert2";

export default function InDocumentChild() {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  console.log(location.state);
  
  let cloneDoc0 =  structuredClone(location.state[0]);
  //console.log(cloneDoc.quantityItems);  
  let auxCloneDoc = cloneDoc0.quantityItems.forEach(e=> e.quantity = "") //por referencia dejo las cantidades en 0 

  let cloneDoc1 = location.state[1] ? structuredClone(location.state[1]) : null
  console.log(cloneDoc1);
  let auxCloneDoc1 = cloneDoc1 !== null ? cloneDoc1.itemsMissing.forEach(e => e.quantity = "") : null

  const initialForm = {
    //numberDocument: "",
    quantityItems: [], //cloneDoc1 ? cloneDoc1.itemsMissing : cloneDoc0.quantityItems,
    dateReception: new Date(),
    itemsMissing:[], //location.state[1] ? location.state[1].itemsMissing : location.state[0].quantityItems,
    userId: "",
    document_id: location.state[0]._id,
    client_id: location.state[0].client_id._id,
  };

  let itemsDocuments = {
    documentId: cloneDoc1 ? cloneDoc1._id : cloneDoc0._id,
    itemsDoc: cloneDoc1 ? cloneDoc1.itemsMissing : cloneDoc0.quantityItems,
  };

  // const missings = {
  //   items: "",
  // };

  const [form, setForm] = useState(initialForm);
  const documents = useSelector((state) => state.documents.allDocuments);  
  const inDocuments = useSelector((state) => state.inDocuments.allInDocuments);
  const [startDate] = useState(new Date());
  let [itemsDocument, setItemsDocument] = useState(itemsDocuments);
  

  useEffect(() => {
    dispatch(getDocuments());
    // dispatch(getItems());
    dispatch(getClientes());
    dispatch(getInDocuments());
  }, [dispatch]);

  console.log(location.state._id);

  const codeDocument = inDocuments[1] + 1;
  
  console.log(documents);
  console.log(inDocuments);

  const documentsInFilter = inDocuments && inDocuments[0].filter(
    (e) => e.client_id[0]._id === form.client_id
  ); //filtro los inDocuments por cliente
  console.log(documentsInFilter);

  const auxDocumentsInFilter =
    documentsInFilter !== null
      ? documentsInFilter.filter(
          (e) => e.document_id && e.document_id._id === form.document_id
        )
      : null;
  console.log(auxDocumentsInFilter);
  const inDocumentLast = auxDocumentsInFilter[0]//[auxDocumentsInFilter.length - 1];
  console.log(inDocumentLast);

  

  
  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleDateReception = (date) => {
    //console.log("FECHA");

    setForm({
      ...form,
      dateReception: date,
    });
  };

  const handleQuantity = (x) => {
    const { value } = x.target;
    //setValue(value)
  };   

  const handleEnterItem = (x, quantity, item) => {
    const { value } = x.target;
    
    if(x.key === "Enter"){
  //     console.log("es la tecla Enter")
    

  //   console.log("esto es valor " + value)
  //   console.log("esto es cantidad " + quantity)
  // Number(quantity) ? console.log("es un numero") : console.log("no es un numero")

  

    if (parseInt(value) === parseInt(quantity)) {
      console.log("Valor y cantidad iguales")
      const aux = form.quantityItems.find((x) => item === x.item);
      console.log(aux)
      if(aux){
      aux.quantity = parseInt(value);
      const deleteItemMissing = form.itemsMissing.filter(e => e.item !== item)
      setForm({
        ...form,         
        itemsMissing: deleteItemMissing,
      });
      } else {        
        const aux = itemsDocument.itemsDoc.find((x) => item === x.item); // se filtra el objeto al cual se le cambia la cantidad
            aux.quantity = value; //se le asigna el valor a la cantidad

            const auxItemQuantity = structuredClone(itemsDocument.itemsDoc); //se guarda en una variable un clon del estado itemsDocument, para evitar referencia y poder hacer diferentes cambios
            const auxItem = auxItemQuantity.find((x) => x.item === item);
            auxItem.quantity = value; //se le asigna el valor a l

            setForm({
              ...form,
              quantityItems: [...form.quantityItems, auxItem]
            })
      }
    }

    if (parseInt(value) < quantity && parseInt(value) > 0) {
      //console.log("valor menor a cantidad")

      Swal.fire("La cantidad es menor a la esperada")
          const itemInclude = form.quantityItems.find((x) => x.item === item);
          const itemsMissingInclude = form.itemsMissing.find((x) => x.item === item);
          console.log(itemInclude, itemsMissingInclude)

          if (itemInclude && itemsMissingInclude) {
            console.log("Entro en el primero");
            itemInclude.quantity = value;
            itemsMissingInclude.quantity = quantity - value;
            setForm({
              ...form,
            });
          } else if(itemInclude && !itemsMissingInclude){
            console.log("Entro en el segundo");
            itemInclude.quantity = value;

            const aux = itemsDocument.itemsDoc.find((x) => item === x.item); // se filtra el objeto al cual se le cambia la cantidad
            aux.quantity = value; //se le asigna el valor a la cantidad

            const auxMissing = structuredClone(itemsDocument.itemsDoc); //se guarda en una variable un clon del estado itemsDocument, para evitar referencia y poder hacer diferentes cambios
            const auxItem = auxMissing.find((x) => x.item === item);
            auxItem.quantity = quantity - value; //se le asigna el valor a l

            setForm({
              ...form,
              itemsMissing: [...form.itemsMissing, auxItem]
            })
          } 
          else {
            console.log("Entro en el tercero")
            /////////////////
            const aux = itemsDocument.itemsDoc.find((x) => item === x.item); // se filtra el objeto al cual se le cambia la cantidad
            aux.quantity = value; //se le asigna el valor a la cantidad

            const auxMissing = structuredClone(itemsDocument.itemsDoc); //se guarda en una variable un clon del estado itemsDocument, para evitar referencia y poder hacer diferentes cambios
            const auxItem = auxMissing.find((x) => x.item === item);
            auxItem.quantity = quantity - value; //se le asigna el valor a la cantidad haciendo quantity - value

            setItemsDocument({ //se actualiza la cantidad con el valor del evento                                
              ...itemsDocument              
            });
            setForm({
              ...form,
              quantityItems: [...form.quantityItems, aux], //se actualizan el estado principal
              itemsMissing: [...form.itemsMissing, auxItem],
            });
          }
    }

    if (value === "0"){
      Swal.fire({
        title: "La cantidad es 0 ¿Esta seguro?",
        showCancelButton: true,
        confirmButtonText: "OK",
      }).then((result) => {
        if (result.isConfirmed) {
          const itemInclude = form.itemsMissing.find((x) => x.item === item);

          if (itemInclude) {
            const auxQuantityItems = form.quantityItems.find(
              (x) => x.item === item
            );
            auxQuantityItems.quantity = value;

            const auxItemMissing = form.itemsMissing.find(
              (x) => x.item === item
            );
            auxItemMissing.quantity = quantity - value;

            setForm({
              ...form,
            });
          } else {
            const aux = itemsDocument.itemsDoc.find((x) => item === x.item); // se filtra el objeto al cual se le cambia la cantidad
            aux.quantity = value; //se le asigna el valor a la cantidad

            const auxMissing = structuredClone(itemsDocument.itemsDoc); //se guarda en una variable un clon del estado itemsDocument, para evitar referencia y poder hacer diferentes cambios
            const auxItem = auxMissing.find((x) => x.item === item);
            auxItem.quantity = quantity - value; //se le asigna el valor a la cantidad haciendo quantity - value

            setItemsDocument({ //se actualiza la cantidad con el valor del evento                                
              ...itemsDocument              
            });
            setForm({
              ...form,
              quantityItems: [...form.quantityItems, aux], //se actualizan el estado principal
              itemsMissing: [...form.itemsMissing, auxItem],
            });
          }
        }
      })
    }

    if (parseInt(value) > quantity) {
      Swal.fire("La cantidad no puede ser mayor a la esperada");
      
    }

    if(value === ""){
        Swal.fire('Debe ingresar una cantidad igual a 0 o mayor')
        // setErrors({
        //   ...errors,
        //   item
        // })
    }
    // else {
    //   setErrors({})
    // }
   }
  };

  const handleSubmit = async (e) => {
    //e.preventDefault();
    console.log(itemsDocument)
    let auxItem = await itemsDocument.itemsDoc.filter(e=> e.quantity === "")
    console.log(auxItem);
    if(auxItem.length > 0){
      Swal.fire("Figuran articulos sin cantidad a saldar, esta debe ser de 0 o superior")
      return
    }
   
    dispatch(postInDocuments(form));
    setForm({
      numberDocument: "",
      quantityItems: [],
      dateReception: "",
      itemsMissing: [],
      userId: "",
      document_id: "",
      client_id: "",
    });
    setTimeout(() => {
      //window.location.reload();
      navigate(`/documentos/${location.state[0]._id}`)      
    }, "300");        
  };

  return (
    <div className="container bg-gray-900">
      <div className="m-8 text-orange-500 font-bold">
      {location.state[0].state === true ? 
        <div className=" text-orange-500">
          <div className="text-[14pt]">No hay documentos a Saldar</div>
          <div className="w-32 bg-slate-700 text-center hover:text-white hover:font-semibold hover:border-white border-2 border-black">
                    <Link to={`/documentos/${location.state[0]._id}`}>
                        <p>Volver</p>                        
                    </Link>
          </div>
        </div>
         
        : 
      <div className="container text-orange-500 text-[10pt] font-bold">
        <div>
          <div className="text-xl pb-8 underline">Pedidos - Devolucion</div>
        </div>
        <div className="flex ">
          <div className="w-1/3">
            <label>N° Documento </label>
            <input
              className="w-10 text-center bg-gray-700 rounded"
              type="text"
              name="numberDocument"
              onChange={handleChange}
              value={codeDocument}
              required={true}
            />
          </div>
          <div className="w-1/3">Fecha: {format(new Date(), "dd/MM/yyyy")}</div>
        </div>
        <div className="flex border-b-2 border-slate-500 pb-2 text-[10pt] pt-2">
          <label className="w-48 text-[10pt]">
            Elegir Fecha de Recepción
          </label>
          <DatePicker
            className="w-24 pl-3 ml-2 rounded bg-slate-700"
            selected={startDate}
            onChange={handleDateReception}
            value={
              form.dateReception
                ? format(form.dateReception, "dd/MM/yyyy")
                : null
            }
          />
        </div>
        <div className="border-b-2 border-slate-500 py-2">
          <div className="flex">
            <p className="w-1/4">
              Cliente N°: {location.state[0].client_id.idClient}
            </p>
            <p className="w-1/4">
              Compañia: {location.state[0].client_id.nameCompany}
            </p>
            <p className="w-1/4">Nombre: {location.state[0].client_id.name}</p>
            <p className="w-1/4">
              Apellido: {location.state[0].client_id.lastName}
            </p>
          </div>
          <div className="flex">
            <p className="w-1/4">
              Dirección: {location.state[0].client_id.address}
            </p>
            <p className="w-1/4">Ciudad: {location.state[0].client_id.city}</p>
            <p className="w-1/4">
              Telefonos: {location.state[0].client_id.telephoneNumber}
            </p>
            <p className="w-1/4">E-mail: {location.state[0].client_id.email}</p>
          </div>
        </div>
        <div className="flex border-b-2 border-slate-500 py-2">
          <p className="w-1/3">N° Documento: {location.state[0].numberDocument}</p>
          <p className="w-1/3">
            Egreso: {format(new Date(location.state[0].dateSend), "dd/MM/yyyy")}
          </p>
          <p className="w-1/3">
            Reingreso:{" "}
            {format(new Date(location.state[0].dateReception), "dd/MM/yyyy")}
          </p>
        </div>
        <div className="font-bold text-[12pt] pt-4">Articulos</div>
        <div className="flex w-full border-b-2 border-slate-500">
          <div className="w-1/3">Nombre</div>
          <div className="w-2/5">Descripción</div>
          
            <div className="w-20 text-center">Cantidad</div>
          
          <div className="w-20 pl-2">A Saldar</div>
          <div className="w-20 text-center">Confirmado</div>
        </div>

        <div className="">
          {inDocumentLast !== undefined ? (
            <div>
              {inDocumentLast.itemsMissing.map((e) => (
                <InDocumentChildCard
                  key={e.item}
                  item={e.item}
                  name={e.name}
                  descrip={e.descrip}
                  quantity={e.quantity}
                  itemsDocument={itemsDocument}
                  form={form}
                  //missing={missing}
                  handleEnterItem={handleEnterItem}
                  handleQuantity={handleQuantity}                  
                  //(x) => handleQuantity(x, e.quantity, e.item)}
                />
              ))}
            </div>
          ) : (
            <div>
              {location.state[0].quantityItems.map((e) => (
                <InDocumentChildCard
                  key={e.item}
                  item={e.item}
                  name={e.name}
                  descrip={e.descrip}
                  quantity={e.quantity}
                  itemsDocument={itemsDocument}
                  form={form}
                  //missing={missing}
                  handleEnterItem={handleEnterItem}
                  handleQuantity={handleQuantity}
                  //(x) => handleQuantity(x, e.quantity, e.item)}
                />
              ))}
            </div>
          )}
        </div>
        <div>
          {form.itemsMissing === undefined ? (
            <div>No hay faltantes de artículos</div>
          ) : (
            <div className="py-4 mt-3">
              <div className="font-bold">Articulos Faltantes</div>
              {form.itemsMissing.map((e, index) => {
                return (
                  <div
                    key={e.item}
                    className="flex text-red-600 border-b-2 border-slate-500"
                  >
                    <div className="w-1/3">{e.name}</div>
                    <div className="w-2/5">{e.descrip}</div>
                    <div className="w-48 text-center">
                      <div className="w-20">{e.quantity}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
        <div>
          <button className="mt-12 p-4 rounded bg-sky-500 text-white" onClick={handleSubmit}>Guardar</button>
        </div>
      </div>
  }
  </div>
    </div>
  );
}
